var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-41",
    "data-name": "50_Kids_Icons-41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4823",
    "data-name": "Group 4823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4806",
    "data-name": "Group 4806",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M0,36.722a40,40,0,1,1,40,40A40,40,0,0,1,0,36.722Z",
    transform: "translate(0 2.766)",
    fill: "#d12c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4807",
    "data-name": "Group 4807",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M163.188,140.534H121V103.816a21.094,21.094,0,0,1,21.094-21.094h0a21.094,21.094,0,0,1,21.094,21.094Z",
    transform: "translate(-102.094 -69.797)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4808",
    "data-name": "Group 4808",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M152.947,243.329c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S151.922,240.9,152.947,243.329Z",
    transform: "translate(-123.38 -202.265)",
    fill: "#b35c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M320,243.329c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S321.025,240.9,320,243.329Z",
    transform: "translate(-269.567 -202.265)",
    fill: "#b35c1f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4809",
    "data-name": "Group 4809",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 17.969,
    cy: 16.449,
    rx: 17.969,
    ry: 16.449,
    transform: "translate(22.031 12.991)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4810",
    "data-name": "Group 4810",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M128.4,409.1l-.008-.132c0-8-3-15.753-6.652-17.229l-15.575-6.275a20.632,20.632,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-59.398 -324.296)",
    fill: "#b35c1f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4811",
    "data-name": "Group 4811",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M226.979,273.845a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V257.827a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-180.384 -212.294)",
    fill: "#b35c1f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4813",
    "data-name": "Group 4813",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4812",
    "data-name": "Group 4812",
    transform: "translate(26.616 17.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M197.112,137.237a13.383,13.383,0,0,1-13.383,13.383h0a13.383,13.383,0,0,1-13.383-13.383V126.105a13.383,13.383,0,0,1,13.383-13.383h0a13.384,13.384,0,0,1,13.384,13.384v11.132Z",
    transform: "translate(-170.345 -112.722)",
    fill: "#c67c47"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4814",
    "data-name": "Group 4814",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_268",
    "data-name": "Ellipse 268",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(33.321 40.997)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_269",
    "data-name": "Ellipse 269",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(43.584 40.997)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4815",
    "data-name": "Group 4815",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M171.161,98.914c-8.677,0-15.711,7.624-15.711,17.029a18.05,18.05,0,0,0,2.13,8.566l.787-6.674a7.435,7.435,0,0,1,7.383-6.564h10.818a7.435,7.435,0,0,1,7.384,6.563l.789,6.676a18.052,18.052,0,0,0,2.13-8.566C186.872,106.538,179.838,98.914,171.161,98.914Z",
    transform: "translate(-131.161 -83.459)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4816",
    "data-name": "Group 4816",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M244.43,276.379a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,244.43,276.379Z",
    transform: "translate(-202.216 -233.195)",
    fill: "#b35c1f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4817",
    "data-name": "Group 4817",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M128.39,421.9c0-8-3-15.752-6.652-17.229l-12.384-4.989a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-59.398 -337.235)",
    fill: "#ffc34a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4818",
    "data-name": "Group 4818",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M229.511,313.089a4.883,4.883,0,0,1-6.487,0c-1.231-1.159-3.091.694-1.856,1.856a7.56,7.56,0,0,0,10.2,0c1.235-1.163-.625-3.015-1.856-1.856Z",
    transform: "translate(-186.267 -263.859)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4819",
    "data-name": "Group 4819",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M205.638,129.882a11.45,11.45,0,0,0,1.6-5.866,11.084,11.084,0,1,0-22.163,0,11.45,11.45,0,0,0,1.6,5.866Z",
    transform: "translate(-156.16 -95.081)",
    fill: "#543f54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4822",
    "data-name": "Group 4822",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4820",
    "data-name": "Group 4820",
    transform: "translate(31.738 38.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M204.312,250.14a2.882,2.882,0,0,1,2.748-.626.686.686,0,0,0,.365-1.323,4.3,4.3,0,0,0-4.082.978c-.656.6.317,1.563.97.97Z",
    transform: "translate(-203.124 -248.03)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4821",
    "data-name": "Group 4821",
    transform: "translate(43.477 38.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M282.821,249.171a4.3,4.3,0,0,0-4.082-.978.686.686,0,0,0,.365,1.323,2.882,2.882,0,0,1,2.748.626c.653.593,1.626-.374.97-.97Z",
    transform: "translate(-278.255 -248.03)",
    fill: "#3d2a3d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar14);
export default __webpack_public_path__ + "static/media/avatar14.a1803817bb3040188b0e6e5dbbbe11bd.svg";
export { ForwardRef as ReactComponent };